import { jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect, useContext } from "react";
import { InvoiceStatus } from "../no-show-fee-list.types.js";
const initialFilters = {
  searchTerm: "",
  date: {
    fromDate: null,
    toDate: null
  },
  status: [InvoiceStatus.OPEN],
  reason: []
};
const NoShowFiltersContext = createContext(void 0);
const NoShowFiltersProvider = ({
  children,
  clinicReferenceId
}) => {
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);
  useEffect(() => {
    var _a, _b;
    if (!clinicReferenceId)
      return;
    const key = `${clinicReferenceId}_NoShowFeeTableFilters`;
    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        setAppliedFilters({
          ...parsed,
          date: {
            fromDate: ((_a = parsed.date) == null ? void 0 : _a.fromDate) ? new Date(parsed.date.fromDate) : null,
            toDate: ((_b = parsed.date) == null ? void 0 : _b.toDate) ? new Date(parsed.date.toDate) : null
          }
        });
      } else {
        localStorage.setItem(key, JSON.stringify(initialFilters));
      }
    } catch (e) {
      console.warn("Error reading filters from localStorage", e);
    }
  }, [clinicReferenceId]);
  useEffect(() => {
    if (!clinicReferenceId)
      return;
    const key = `${clinicReferenceId}_NoShowFeeTableFilters`;
    try {
      localStorage.setItem(key, JSON.stringify(appliedFilters));
    } catch (e) {
      console.warn("Error saving filters to localStorage", e);
    }
  }, [clinicReferenceId, appliedFilters]);
  return /* @__PURE__ */ jsx(NoShowFiltersContext.Provider, { value: { appliedFilters, setAppliedFilters }, children });
};
const useNoShowFilters = () => {
  const context = useContext(NoShowFiltersContext);
  if (context === void 0) {
    throw new Error("useNoShowFilters must be used within a NoShowFiltersProvider");
  }
  return context;
};
export {
  NoShowFiltersProvider,
  initialFilters,
  useNoShowFilters
};
